import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import $ from "jquery";
import imgVer from "./js/imgver";
import "./assets/css/imgver.css";
import "./assets/css/layout.css";

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$imgVer = imgVer;

axios.get("/project.config.json").then((res) => {
  window.url = res.data.ApiUrl;
  new Vue({
    router,
    store,
    axios,
    render: (h) => h(App),
  }).$mount("#app");
});
